import {
  IAdvancedRichText,
  IAssignableExpression,
  IInputWidget,
  WidgetType,
} from '@framework/engine';

export const WidgetProvinceType = 'province' as WidgetType.Province;

/**
 * Interfaccia Download Widget
 */
export interface IProvinceWidget extends IInputWidget {
  id: string;
  type: WidgetType.Province;
  // label?: IAdvancedRichText;
  provinceLabel?: IAdvancedRichText;
  townLabel?: IAdvancedRichText;
  provincePlaceholder?: string | null;
  townPlaceholder?: string | null;
  provinceHelpText?: IAdvancedRichText;
  townHelpText?: IAdvancedRichText;

  // Gestiamo i campi di default del widget
  // con un sistema custom, slegato dal normale "defaultValue"
  // degli InputWidget
  defaultProvince?: IAssignableExpression;
  defaultTown?: IAssignableExpression;
}
